module.exports = __webpack_public_path__ + "img/HeroTypesQuiz_Gadgeteer.68ab798c.png";